import { useQuery } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { ComponentProps } from 'react';

import { Learn as LearnScreen, LearnSessionsFragment } from '@oui/app-core/src/screens/Learn';
import { useTheme } from '@oui/app-core/src/styles';
import { LearnStatic } from '@oui/app-static/src/screens/LearnStatic';
import { graphql } from '@oui/lib/src/graphql/tada';
import { ContentType } from '@oui/lib/src/types';

import { WeeklyPracticeFragment } from '@src/components/WeeklyPractice/WeeklyPractice';
import { TabScreenProps } from '@src/types/navigation';

export const PtsdLearnQuery = graphql(
  `
    query PtsdLearn {
      user {
        ID
        role {
          ID
          productStatic
          ...LearnSessions
        }
      }
      ...WeeklyPractice
    }
  `,
  [LearnSessionsFragment, WeeklyPracticeFragment],
);

const STATIC_SESSIONS = [
  {
    ordinal: 1,
    title: `Session 1`,
    subtitle: null,
    description: '',
    slug: ContentType.STATIC_01,
    unlockedAt: null,
  },
  {
    ordinal: 2,
    title: `Session 2`,
    subtitle: null,
    description: '',
    slug: ContentType.STATIC_02,
    unlockedAt: null,
  },
  {
    ordinal: 3,
    title: `Session 3`,
    subtitle: null,
    description: '',
    slug: ContentType.STATIC_03,
    unlockedAt: null,
  },
] as ComponentProps<typeof LearnStatic>['sessions'];

export function Learn(_props: {}) {
  const navigation = useNavigation<TabScreenProps<'Learn'>['navigation']>();
  const { theme } = useTheme();
  const { data } = useQuery(PtsdLearnQuery);

  const isStatic = !!data?.user?.role?.productStatic;

  // This is a bit hacky, we want to leverage the unlocking logic from the
  // treatment arm but use the session titles from the static data here to
  // match how we implement static sessions for other apps
  if (isStatic) {
    STATIC_SESSIONS![0].unlockedAt = data?.user?.role?.sessions[0].unlockedAt;
    STATIC_SESSIONS![1].unlockedAt = data?.user?.role?.sessions[1].unlockedAt;
    STATIC_SESSIONS![2].unlockedAt = data?.user?.role?.sessions[2].unlockedAt;
    return <LearnStatic sessions={STATIC_SESSIONS} />;
  }

  return (
    <LearnScreen
      title="Home"
      onSessionCardPress={(session, sessionNum) => {
        const isComplete = session.status === 'COMPLETED';

        navigation.navigate('Conversation', {
          num: sessionNum.toString(),
          title: session.session.name,
          ID: session.session.contentType || 'TEST::convo',
          completed: isComplete ? ('true' as const) : ('false' as const),
        });
      }}
      progressBackgroundColor={theme.color.accent100}
      paddingBottom={150}
    />
  );
}
